import React from "react";

const Initiative = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_20304)">
        <path
          d="M12.9805 5.66998V3M18.3306 11H21.0005M18.6506 16.66L16.7606 14.77M9.21057 7.21997L7.32056 5.34003M16.7606 7.21002L18.6506 5.32001M13.0105 13.83C13.7905 13.05 13.7905 11.78 13.0105 11C12.2205 10.22 10.9605 10.22 10.1705 11L3.59055 17.59C2.80055 18.37 2.80055 19.64 3.59055 20.42C4.37055 21.2 5.6405 21.2 6.4205 20.42L13.0105 13.83Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_20304">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Initiative;
